import type React from 'react';

// src/components/organism/CreateSix/CreateSixStepper.tsx
import { useCreateSixStepper } from '@/hooks/createSix/useCreateSixStepper';
import { getStepConfig } from '@/components/organism/CreateSix/stepConfig';

interface CreateSixStepperProps {
  onClose: () => void;
}

function CreateSixStepper({ onClose }: CreateSixStepperProps): React.JSX.Element {
  const { state } = useCreateSixStepper();
  const { component: StepComponent } = getStepConfig(state.step);
  return <StepComponent onClose={onClose} />;
}

CreateSixStepper.displayName = 'CreateSixStepper';

export default CreateSixStepper;
